import { h, Component, createRef } from 'preact'
import cn from 'classnames'
import s from './Cropper.css'

interface iProps {
  className?: string
  imageUrl: string
}

class Cropper extends Component<iProps> {
  ref = createRef<HTMLCanvasElement>()
  context: any
  image = new Image()

  isDraggable: boolean = false
  offsetLeft: number = 0
  offsetTop: number = 0
  currentX: number = 0
  currentY: number = 0

  componentDidMount () {
    this.cropImage()
  }

  cropImage = () => {
    const { current: canvas } = this.ref

    if (!canvas) {
      return
    }

    const { imageUrl } = this.props

    this.context = canvas.getContext('2d')
    this.image.src = imageUrl

    this.image.onload = () => {
      setInterval(() => {
        this.resetCanvas(canvas)
        this.drawImage()
      }, 40)
    }
  }

  drawImage = () => {
    const dx = this.currentX - (this.image.width / 2)
    const dy = this.currentY - (this.image.height / 2)

    this.context.drawImage(this.image, dx, dy)
  }

  resetCanvas = (canvas: HTMLCanvasElement) => {
    this.context.fillStyle = '#fff'
    this.context.fillRect(0, 0, canvas.width, canvas.height)
  }

  onMouseDown = (e: MouseEvent) => {
    const mouseX = e.pageX - this.offsetLeft
    const mouseY = e.pageY - this.offsetTop

    if (mouseX >= (this.currentX - this.image.width / 2) &&
      mouseX <= (this.currentX + this.image.width / 2) &&
      mouseY >= (this.currentY - this.image.height / 2) &&
      mouseY <= (this.currentY + this.image.height / 2)) {
      this.isDraggable = true
    }
  }

  onMouseMove = (e: MouseEvent) => {
    if (this.isDraggable) {
      this.currentX = e.pageX - this.offsetLeft
      this.currentY = e.pageY - this.offsetTop
    }
  }

  stopDragging = (e: MouseEvent) => {
    this.isDraggable = false
  }

  render () {
    const { className } = this.props

    return (
      <div className={cn(s.Cropper, className)}>
        <div
          className={s.Cropper__circle}
          onMouseDown={this.onMouseDown}
          onMouseMove={this.onMouseMove}
          onMouseUp={this.stopDragging}
          onMouseOut={this.stopDragging}
        />
        <canvas
          ref={this.ref}
          className={s.Cropper__canvas}
        />
      </div>
    )
  }
}

export default Cropper
